import React, { useState, useContext } from "react";
import axios from "axios";
import { UsersData } from "src/ContextAPI";
import IsMountedRef from "src/utils/IsMountedRef";
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Dialog,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  FormHelperText,
  Typography,
} from "@material-ui/core";
import Notify from "src/notification/Notify";
import ProcessPhilhealth from "./ProcessPhilhealth";
import SendToCashier from "./SendToCashier";

const Details = ({ details, getAdmittedPatientsForBillout, resetDisplay }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [patientBills, setPatientBills] = useState([]);
  const { users } = useContext(UsersData);
  const mounted = IsMountedRef();

  const [processPhilDialog, setProcessPhilDialog] = useState({
    open: false,
  });

  const [sentToCashierDialog, setSentToCashierDialog] = useState({
    open: false,
  });

  const getallBillForPaymentByPatient = React.useCallback(async () => {
    axios
      .get(`billing/admitted/patient/get-patient-billslist`, {
        params: {
          patient_id: details?.patient_id,
          trace_number: details?.trace_number,
          management_id: users?.management_id,
          main_mgmt_id: users?.main_mgmt_id,
        },
      })
      .then(({ data }) => {
        if (mounted.current) {
          setPatientBills(data);
        }
      })
      .catch((err) => console.log(`error:`, err.message))
      .finally(() => setIsLoading(false));
  }, [details, mounted, users]);

  React.useEffect(() => {
    getallBillForPaymentByPatient();
  }, [getallBillForPaymentByPatient]);

  let totalbill = 0;

  return (
    <Box>
      <Card>
        <CardHeader title="Patients Bill" />
        <CardContent>
          <Box>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <strong> Bill </strong>
                  </TableCell>
                  <TableCell>
                    <strong> Type </strong>
                  </TableCell>
                  <TableCell>
                    <strong> Amount </strong>
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {!isLoading ? (
                  patientBills.length > 0 ? (
                    patientBills.map((data, key) => (
                      <TableRow key={key}>
                        <TableCell> {data.bill_name} </TableCell>
                        <TableCell> {data.bill_from} </TableCell>
                        <TableCell align="right">
                          {data.bill_amount}

                          <span hidden>
                            {(totalbill += parseFloat(data.bill_amount))}
                          </span>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={3}>
                        <Typography color="secondary">
                          No record found.
                        </Typography>
                      </TableCell>
                    </TableRow>
                  )
                ) : (
                  <TableRow>
                    <TableCell colSpan={3}>
                      <Typography color="primary">
                        Loading, please wait...
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}

                <TableRow>
                  <TableCell colSpan={2}>
                    <strong>Bill Amount</strong>
                  </TableCell>
                  <TableCell align="right">
                    <strong>{Notify.convertToNumber(totalbill)}</strong>
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell colSpan={2}>
                    <strong>Amount Philhealth </strong>
                  </TableCell>
                  <TableCell align="right">
                    <strong>
                      {Notify.convertToNumber(
                        patientBills?.[0]?.philhealth_amount ?? 0
                      )}
                    </strong>
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell colSpan={2}>
                    <strong>Total Amount To Pay </strong>
                  </TableCell>
                  <TableCell align="right">
                    <strong>
                      {Notify.convertToNumber(
                        totalbill -
                          parseFloat(patientBills?.[0]?.philhealth_amount ?? 0)
                      )}
                    </strong>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Box>

          {details?.billout_status === "for-cashier" && (
            <Box mt={2}>
              <FormHelperText error>
                Patient is successfully move to cashier for discharge slip or
                payment if needed.
              </FormHelperText>
            </Box>
          )}
        </CardContent>

        <CardActions>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              setProcessPhilDialog({
                open: true,
              });
            }}
            disabled={
              Boolean(patientBills?.[0]?.philhealth_amount) ||
              patientBills.length === 0
            }
          >
            Process philhealth
          </Button>

          <Button
            variant="contained"
            color="primary"
            disabled={
              Boolean(details?.billout_status === "for-cashier") ||
              patientBills.length === 0
            }
            onClick={() => {
              setSentToCashierDialog({
                open: true,
              });
            }}
          >
            Send to cashier
          </Button>
        </CardActions>
      </Card>

      <Dialog
        open={processPhilDialog.open}
        onClose={() => {
          setProcessPhilDialog({
            open: false,
          });
        }}
        fullWidth
        maxWidth={"xs"}
      >
        <DialogTitle> Process Philhealth </DialogTitle>
        <ProcessPhilhealth
          trace_number={details?.trace_number}
          patient_id={details?.patient_id}
          onClose={() => {
            setProcessPhilDialog({
              open: false,
            });
          }}
          getallBillForPaymentByPatient={getallBillForPaymentByPatient}
        />
      </Dialog>

      <Dialog
        open={sentToCashierDialog.open}
        onClose={() => {
          setSentToCashierDialog({
            open: false,
          });
        }}
        fullWidth
        maxWidth={"xs"}
      >
        <DialogTitle> Sent to cashier </DialogTitle>
        <SendToCashier
          trace_number={details?.trace_number}
          patient_id={details?.patient_id}
          onClose={() => {
            setSentToCashierDialog({
              open: false,
            });
          }}
          getAdmittedPatientsForBillout={getAdmittedPatientsForBillout}
          getallBillForPaymentByPatient={getallBillForPaymentByPatient}
          resetDisplay={resetDisplay}
          amount={
            totalbill -
            (patientBills?.[0]?.philhealth_amount === null
              ? 0
              : parseFloat(patientBills?.[0]?.philhealth_amount))
          }
        />
      </Dialog>
    </Box>
  );
};

export default Details;
